export default "__VITE_ASSET__C7MjWs37__"